import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const MobileStepIcon = ({ active, isCompleted }) => {
  const activeClass = active ? 'active' : '';
  const completedClass = isCompleted && !active ? 'completed' : '';

  return (
    <div className={`mobile-step-icon ${activeClass} ${completedClass}`} />
  );
};

MobileStepIcon.propTypes = {
  active: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
};

export default MobileStepIcon;
